/* src/components/project-quickscan/project-quickscan.component.scss */
:host {
  display: block;
  --table-border-size: 1px;
}
.quickscan {
  padding-left: var(--vwui-size-component-nav);
}
/*# sourceMappingURL=project-quickscan.component-GUZ7FVES.css.map */
